import { createActions, createReducer } from 'reduxsauce'

import GruposContabeisService from '../../servicos/GruposContabeisService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaGruposContabeisInicio: [],
    buscaGruposContabeisSucesso: ['gruposContabeis'],
    buscaGruposContabeisErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataAtualizacaoDados: null,
}

// Ação para busca completa
Creators.buscaGruposContabeis = modelo => {
    return dispatch => {
        dispatch(Creators.buscaGruposContabeisInicio())
        let serv = new GruposContabeisService()
        serv.getGruposContabeis(modelo)
            .then(response => dispatch(Creators.buscaGruposContabeisSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaGruposContabeisErro(error)))
    }
}

const buscaGruposContabeisInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaGruposContabeisErro = (state = INITIAL_STATE, action) => ({ ...state, carregando: false, erro: action.erro })

const buscaGruposContabeisSucesso = (state = INITIAL_STATE, action) => {
    if (action.gruposContabeis.length > 0) {
        return { ...state, lista: action.gruposContabeis, dataAtualizacaoDados: action.gruposContabeis.dataAtualizacaoDados, carregando: false }
    } else {
        return { ...state, carregando: false }
    }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_GRUPOS_CONTABEIS_INICIO]: buscaGruposContabeisInicio,
    [Types.BUSCA_GRUPOS_CONTABEIS_ERRO]: buscaGruposContabeisErro,
    [Types.BUSCA_GRUPOS_CONTABEIS_SUCESSO]: buscaGruposContabeisSucesso,
})
